import { Injectable } from '@angular/core';
import { ApiRoutes } from '@sb/library/api';
import { SortDirection } from '@sb/library/base';
import { TimeZoneInfoDisplayItem } from '@sb/library/data-models';
import { map, Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class TimeZoneManager {

    private _timeZones: TimeZoneInfoDisplayItem[] = [];
    private _timeZoneObservable: Observable<TimeZoneInfoDisplayItem[]>;

    constructor () {
        this._timeZoneObservable = ApiRoutes.Localization.TimeZones.GetAll.Call().pipe(map(timeZones => 
            timeZones.orderByKey('UTCOffsetInMinutes', SortDirection.Ascending, undefined, 'DisplayName', SortDirection.Ascending)
        ));

        this._timeZoneObservable.subscribe(sortedTimeZones => {
            this._timeZones = sortedTimeZones;
            this._timeZoneObservable = of(this._timeZones);
        });
    }

    get timeZones(): TimeZoneInfoDisplayItem[] {
        return this._timeZones;
    }

    get timeZoneObservable(): Observable<TimeZoneInfoDisplayItem[]> {
        return this._timeZoneObservable;
    }
}
